<template>
  <div>
    <div class="logo"></div>
    <!-- <div class="login-regist">
      <div @click='seleteRouter(index)' :class="{'active': index === nowIndex}" :key='index' v-for='(item,index) in routerList'>{{item}}</div>
    </div> -->
    <div @keydown.enter='changePass' class="about-login">
      <div class="account">
        <input v-model='oldPasswd' placeholder='请输入新密码' type="password" />
      </div>
      <div class="password">
        <input v-model='newPasswd' placeholder='请输入新密码' type="password" />
      </div>
      <p class="wrong"></p>
      <button class="login-button" @click="changePass">确认修改</button>
    </div>
  </div>
</template>
<script type="text/javascript">
  import { apiUrl } from '../../apiUrl.js'
  import { eventBus } from '../../eventBus.js'
  export default {
    data() {
      return {
        oldPasswd: '',
        newPasswd: '',
        loginInfo: {}
      }
    },
    created() {
      this.loginInfo = JSON.parse(localStorage.getItem('loginInfo'))
    },
    methods: {
      changePass() {
        if(this.oldPasswd.length < 6 || this.oldPasswd.length > 20) {
          this.$message.error('密码应为6-20位');
        }else if(this.newPasswd.length < 6 || this.newPasswd.length > 20) {
          this.$message.error('密码为6-20位!');
        }else {
          var changePasswordUrl = apiUrl + 'api/user/changePassword?uid=' + this.loginInfo.uid + '&token=' + this.loginInfo.token + '&old=' + this.oldPasswd + '&new=' + this.newPasswd
          this.axios.post(changePasswordUrl)
          .then((res) => {
            if(res.data.code == 200) {
              this.$message.success('修改成功！')
              eventBus.$emit('close-change-pass')
              this.oldPasswd = ''
              this.newPasswd = ''
            }else if(res.data.code == 201) {
              this.$message.error(res.data.msg)
              this.$router.push('/index')
              eventBus.$emit('change-index')
            }else {
              this.$message.error(res.data.msg)
            }
          })
        }
      },
    }
  }
</script>
<style scoped>
  .logo {
    display: block;
    width: 93px;
    height: 93px;
    margin: 0 auto 34px;
    background: url(../../assets/72.png) 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 20px 0 20px 0;
    box-shadow: 0 0 20px 0 #ddd;
  }
  .account input,.password input{
    display: block;
    width: 282px;
    height: 40px;
    padding-left: 48px;
    margin-bottom: 16px;
    border: none;
    outline: none;
    font-size: 14px;
    line-height: 40px;
    color: #333;
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    background: url(../../assets/19.png) 20px center no-repeat;
    background-size: 17px 20px;
  }
  .password input,.r-password input {
    background: url(../../assets/20.png) 19px center no-repeat;
    background-size: 19px 22px;
  }
  .login-button {
    display: block;
    width: 332px;
    height: 40px;
    margin: 0 auto;
    padding: 0;
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background: #40c0c0;
    border-radius: 5px;
  }
  input:hover {
    border-color: #40c0c0;
  }
  input[type="text"]:focus, 
  input[type="password"]:focus { 
    border-color: #40c0c0;
  }
</style>


// WEBPACK FOOTER //
// src/components/user/changePass.vue